'use client'

import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { LinkField, linkUrl } from '@/lib/link'
import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxAssettext } from './Assettext'
import { AssettextProps } from './Assettext'

interface AssettextBlokProps {
  blok: {
    title: AssettextProps['title']
    subtitle: AssettextProps['subtitle']
    subtitle_asset?: any
    content?: SbBlokData[]
    stickyContent?: boolean
    button?: SbBlokData[]
    asset?: SbBlokData[]
    assetUrl: LinkField
    reverse?: AssettextProps['reverse']
    mobileReverse?: AssettextProps['mobileReverse']
    layout?: AssettextProps['layout']
    secondary_content_layout: any
    padding?: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
    feature?: boolean
    featureVariant?: 'primary' | 'secondary' | 'tertiary'
    featureStyle?: 'default' | 'centered' | 'float'
    featureWaveStyle?: 'top' | 'bottom' | 'both'
    formAlign?: boolean
  } & SbBlokData
  rels?: any[]
}

const Assettext: FC<AssettextBlokProps> = ({ blok, rels }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)
  const href = linkUrl(blok.assetUrl)

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxAssettext
        title={blok.title}
        subtitle={blok.subtitle}
        subtitle_asset={
          blok.subtitle_asset && { src: blok.subtitle_asset.filename, alt: blok.subtitle_asset.alt }
        }
        content={
          blok.content &&
          blok.content.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} rels={rels} />
          ))
        }
        stickyContent={blok.stickyContent ? blok.stickyContent : false}
        button={
          blok.button &&
          blok.button.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} rels={rels} />
          ))
        }
        asset={
          blok.asset &&
          blok.asset.map((nestedBlok: SbBlokData) => {
            return <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} rels={rels} />
          })
        }
        assetLink={
          blok.assetUrl && href
            ? {
                url: href,
                target: blok.assetUrl.target,
              }
            : undefined
        }
        assetCount={blok.asset ? blok.asset.length : 1}
        reverse={blok.reverse}
        mobileReverse={blok.mobileReverse}
        layout={blok.layout}
        secondary_content_layout={blok.secondary_content_layout}
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        alignment={stylePanel.alignment as 'left' | 'center' | 'right'}
        feature={blok.feature ? blok.feature : false}
        featureVariant={blok.featureVariant && blok.featureVariant}
        featureStyle={blok.featureStyle && blok.featureStyle}
        featureWaveStyle={blok.featureWaveStyle && blok.featureWaveStyle}
        formAlign={blok.formAlign}
      />
    </div>
  )
}

export default Assettext
